// @ts-nocheck
// Exact live (2026-10-15) version restored from the production sourcemap.
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ClipboardExport, Eye } from 'iconsax-react';
import { black500 } from '../../../../constants/color';
import { ReactComponent as TickIcon } from '../../../../../../public/assets/icons/tick.svg';
import { getColorAndBackground } from '../../../../constants/helper';
import { IconBox } from '../style';
import { PrimaryGrid } from '../../../../components/common/grid/PrimaryGrid';
import { PrimaryButon } from '@ui/components/common/button/PrimaryButon';
import { EditHour } from '../dialog/EditHours';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RejectedReason } from '../dialog/RejectedReason';
import { HoursStatus } from '@application/common/enums/hours-status';
import { formatDayLabel } from '../hours-dates';
export default function HoursTable({ openDialog, weekNo, selectedClientOption, rows: hoursLoggedWrtAssigmentId, context, reasons, onSaved }) {
    const [isHourEdit, setIsHourEdit] = useState(false);
    const [isReason, setisReason] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null); // Updated type
    const location = useLocation();
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('xs'));
    const isSm = useMediaQuery(theme.breakpoints.between('sm', 1920));
    const isMdUp = useMediaQuery(theme.breakpoints.up(1920));
    const height = isXs ? 300 : isSm ? 300 : isMdUp ? 500 : 'auto';
    const formattedHoursLogged = hoursLoggedWrtAssigmentId?.map((log) => ({
        ...log,
        date: formatDayLabel(log.date),
        // Days without a saved registration stay empty instead of showing a prefilled 0.
        hours: log.isPersisted === false && !Number(log.hours) ? '' : log.hours
    })) ?? [];
    const dateHoursMap = new Map();
    hoursLoggedWrtAssigmentId?.forEach((row) => {
        if (!dateHoursMap.has(row.date)) {
            dateHoursMap.set(row.date, row.totalHoursInADay);
        }
    });
    const totalSum = Array.from(dateHoursMap.values()).reduce((sum, hours) => sum + hours, 0);
    // Phones: short headers so the five columns stay readable instead of truncating.
    const narrow = useMediaQuery('(max-width:599.95px)');
    const columns = [
        { field: 'date', headerName: 'Date', flex: narrow ? 1.3 : 1.5 },
        { field: 'client', headerName: narrow ? 'Type' : 'Registration', flex: narrow ? 0.9 : 1 },
        { field: 'hours', headerName: narrow ? 'Hrs' : 'Register', flex: 0.5 },
        {
            field: 'dailyStatus',
            headerName: narrow ? 'Done' : 'Filled in',
            flex: narrow ? 0.7 : 0.5,
            // Days only show whether they are filled in; review statuses belong to the month.
            renderCell: (params) => {
                const filled = params.row.dailyStatus != null && params.row.dailyStatus !== HoursStatus.Open;
                return (_jsx(_Fragment, { children: filled && _jsx(Box, { sx: { ...IconBox, background: getColorAndBackground('Complete').background }, role: 'img', "aria-label": 'Filled in', title: 'Filled in', children: _jsx(TickIcon, {}) }) }));
            }
        }
    ];
    if (location.pathname.includes('rejected')) {
        columns.push({
            field: 'view',
            headerName: 'View',
            headerAlign: 'center',
            align: 'center',
            flex: narrow ? 0.6 : 1,
            renderCell: (params) => (_jsx(IconButton, { onClick: () => {
                    setSelectedDate({
                        date: params.row.date, weekNo: weekNo, id: params.row.id,
                        dailyStatus: params.row.dailyStatus, totalHoursInADay: params.row.totalHoursInADay
                    });
                    setIsHourEdit(true);
                }, children: _jsx(Eye, {}) }))
        });
    }
    columns.push({
        field: 'edit',
        headerName: 'Edit',
        headerAlign: 'center',
        align: 'center',
        flex: narrow ? 0.6 : 1,
        renderCell: (params) => (_jsx(IconButton, { onClick: () => {
                setIsHourEdit(true);
                setSelectedDate({
                    date: params.row.date, weekNo: weekNo, id: params.row.id,
                    dailyStatus: params.row.dailyStatus, totalHoursInADay: params.row.totalHoursInADay
                });
            }, disabled: !params.row.weekVersion || params.row.dailyStatus === HoursStatus.Pending || params.row.dailyStatus === HoursStatus.Approved, children: _jsx(ClipboardExport, {}) }))
    });
    return (_jsxs("div", { style: {
            background: 'white',
            borderBottomLeftRadius: '25px',
            borderBottomRightRadius: '25px'
        }, children: [_jsx(PrimaryGrid, { columns: columns, h: height, rows: formattedHoursLogged }), formattedHoursLogged && formattedHoursLogged.length > 0 && (_jsxs(Grid, { container: true, pl: 2, borderRadius: '25px', pr: 2, justifyContent: 'flex-end', py: 4, spacing: 4, children: [_jsx(Grid, { item: true, md: 7, children: _jsx(Typography, { variant: 'subtitle2', color: black500, children: "Week total" }) }), _jsx(Grid, { item: true, md: 2, children: _jsx(Typography, { variant: 'body2', color: '#49402A', children: totalSum }) }), _jsx(Grid, { item: true, md: 3, xs: 9, sx: { display: 'flex', justifyContent: 'end' }, children: _jsx(Box, { width: 175, children: !!formattedHoursLogged[0]?.weekVersion && !formattedHoursLogged.some((x) => [HoursStatus.Pending, HoursStatus.Approved].includes(x.dailyStatus)) && _jsx(PrimaryButon, { onClick: openDialog, children: "Fill in weekly hours" }) }) })] })), isHourEdit && selectedDate && _jsx(EditHour, { rows: hoursLoggedWrtAssigmentId.filter((row) => row.id === selectedDate.id), allRows: hoursLoggedWrtAssigmentId, context: context, label: selectedClientOption?.label || '', reasons: reasons, onClose: (reload) => {
                    setIsHourEdit(false);
                    if (reload)
                        onSaved();
                }, onSaved: () => { setIsHourEdit(false); onSaved(); } }), _jsx(RejectedReason, { open: isReason, handleClose: () => setisReason(false) })] }));
}
